// extracted by mini-css-extract-plugin
export default {"patentPortal_Search":"Search_patentPortal_Search__9311r","search_icon":"Search_search_icon__8G3TA"};